// Lista curada de zonas horarias IANA frecuentes para ParkNova (México y LatAm + algunas comunes).
// El backend valida cualquier IANA; esta lista es solo para el selector. No permitir valores libres.
export const TIMEZONES = [
  { value: "America/Mexico_City", label: "Ciudad de México (Centro)" },
  { value: "America/Tijuana", label: "Tijuana / Baja California (Pacífico)" },
  { value: "America/Hermosillo", label: "Hermosillo / Sonora (sin horario de verano)" },
  { value: "America/Cancun", label: "Cancún / Quintana Roo (Este)" },
  { value: "America/Monterrey", label: "Monterrey" },
  { value: "America/Merida", label: "Mérida" },
  { value: "America/Chihuahua", label: "Chihuahua" },
  { value: "America/Bogota", label: "Bogotá (Colombia)" },
  { value: "America/Guayaquil", label: "Guayaquil / Quito (Ecuador)" },
  { value: "America/Lima", label: "Lima (Perú)" },
  { value: "America/Santiago", label: "Santiago (Chile)" },
  { value: "America/Argentina/Buenos_Aires", label: "Buenos Aires (Argentina)" },
  { value: "America/Sao_Paulo", label: "São Paulo (Brasil)" },
  { value: "America/New_York", label: "Nueva York (EE.UU. Este)" },
  { value: "America/Los_Angeles", label: "Los Ángeles (EE.UU. Pacífico)" },
  { value: "Europe/Madrid", label: "Madrid (España)" },
  { value: "Europe/London", label: "Londres (Reino Unido)" },
];

export const DEFAULT_TIMEZONE = "America/Mexico_City";
